var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobileApp)?_c('span',{staticClass:"flex flex-col p-2 ds-text-sm font-medium text-gray-900 bg-gray-200 border border-blue-300 border-solid rounded"},[_c('span',[_vm._v(" College coach? "),_c('a',{staticClass:"font-bold",attrs:{"href":"/login"}},[_vm._v("Log in")]),_vm._v(" to see "+_vm._s(_vm.user.firstName)+"'s full profile. ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }